import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Advertorial } from './components/Advertorial';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k89qfoo0ilfs">
      <MetaPixel data-id="element-1" data-mp="3k8t8r6hkrbuc" />
      <Routes data-id="element-2" data-mp="3k78fdk6zxyy2">
        <Route path="/magnesium" element={<Advertorial data-id="element-4" data-mp="3fbjb53k17tvf" />} data-id="element-3" data-mp="3fahwyq7pyr9h" />
        <Route path="/" element={<Navigate replace to="/magnesium" data-id="element-6" data-mp="3f8nfjlvnpha5" />} data-id="element-5" data-mp="3fb9jlbjc9enm" />
        <Route path="*" element={<Navigate replace to="/magnesium" data-id="element-8" data-mp="2rl6un4aq0ot8" />} data-id="element-7" data-mp="2rlypgcwhuiig" />
      </Routes>
    </BrowserRouter>;
}